"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrcadBusMemberGroupingRule = void 0;
const NetNamingRules_1 = require("../../../../NetCombobulation/NetNamingRules");
class OrcadBusMemberGroupingRule {
    constructor() {
        this.type = NetNamingRules_1.NetNamingRuleType.Group;
    }
    apply(manager, _hierarchy) {
        const busGroups = manager.findGroupsWithObjectsOnDimension('bus');
        for (const busGroup of busGroups) {
            this.mergeBusMembers(manager, busGroup);
        }
        return manager;
    }
    mergeBusMembers(manager, busGroup) {
        const membersByIndex = new Map();
        for (const [instance, nets] of busGroup.getNets()) {
            let membersFound = false;
            for (const net of nets) {
                if (membersFound) {
                    break;
                }
                for (const obj of net.netObjects) {
                    const busMetadata = obj.wire?.strategyMetadata?.bus;
                    if (busMetadata?.members) {
                        for (const member of busMetadata.members) {
                            const entries = membersByIndex.get(member.index) ?? [];
                            entries.push({ instance, memberName: member.name });
                            membersByIndex.set(member.index, entries);
                        }
                        membersFound = true;
                        break;
                    }
                }
            }
        }
        for (const [_index, entries] of membersByIndex) {
            const entriesByInstance = new Map();
            for (const entry of entries) {
                const localEntries = entriesByInstance.get(entry.instance) ?? [];
                localEntries.push(entry);
                entriesByInstance.set(entry.instance, localEntries);
            }
            for (const localEntries of entriesByInstance.values()) {
                this.mergeLocalMembers(manager, localEntries);
            }
        }
    }
    mergeLocalMembers(manager, entries) {
        if (entries.length < 2) {
            return;
        }
        const groupsToMerge = [];
        const seen = new Set();
        for (const { instance, memberName } of entries) {
            const matchingGroups = manager
                .findGroupsWithLabel('alias', memberName, instance)
                .concat(manager.findGroupsWithLabel('virtual-bus-member', memberName, instance));
            for (const group of matchingGroups) {
                if (group.hasObjectsOnDimensionMatching((dimension) => dimension.endsWith('-pos'))) {
                    continue;
                }
                if (!seen.has(group)) {
                    seen.add(group);
                    groupsToMerge.push(group);
                }
            }
        }
        if (groupsToMerge.length >= 2) {
            manager.mergeGroups(...groupsToMerge);
        }
    }
}
exports.OrcadBusMemberGroupingRule = OrcadBusMemberGroupingRule;
//# sourceMappingURL=OrcadBusMemberGroupingRule.js.map